import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'
import LoginLayout from '@/views/LoginLayout'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      redirect: '/user/home',
      meta: {
        nav: 'home'
      }
    },

    {
      path: '/login',
      name: 'Login',
      component: LoginLayout,
      redirect: '/login/main',
      children: [
        {
          path: 'main',
          name: 'login-main',
          component: () => import('@/views/login'),
          meta: {
            unauth: true
          }
        },

        {
          path: '/resetpwd/:admin?',
          name: 'resetpwd',
          component: () => import('@/views/resetpwd'),
          meta: {
            unauth: true
          },
          props({ params: { admin } }) {
            return {
              admin: admin == 'admin'
            }
          }
        }
      ]
    },

    {
      path: '/register',
      name: 'register',
      component: LoginLayout,
      redirect: '/register/main',
      children: [
        {
          path: 'main',
          name: 'register-main',
          component: () => import('@/views/regist'),
          meta: {
            unauth: true
          }
        }
      ]
    },

    {
      path: '/:role',
      name: 'Layout',
      component: Layout,
      redirect: '/:role/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/Home'),
          prop: true,
          meta: {
            nav: 'my'
          }
        },

        // 热点访谈
        {
          path: 'talk',
          name: 'talk',
          component: () => import('@/views/talk/index.vue'),
          props: true,
          meta: {
            nav: 'talk'
          }
        },

        // 我的问答
        {
          path: 'myask',
          name: 'myask',
          component: () => import('@/views/my/ask.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },

        {
          path: 'recommendCourse',
          name: 'recommendCourse',
          component: () => import('@/views/my/recommendCourse.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },

        // 用户：我的作业
        {
          path: 'myhomework',
          name: 'myhomework',
          component: () => import('@/views/my/homework.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },

        // 管理员：管理作业
        {
          path: 'homework',
          name: 'homework',
          component: () => import('@/views/admin/homework.vue'),
          props: true,
          meta: {
            nav: 'homework'
          }
        },

        // 课程
        {
          path: 'manage',
          name: 'manage',
          component: () => import('@/views/Manage'),
          prop: true,
          meta: {
            useSearch: true,
            nav: 'course'
          }
        },

        // 职场充电
        {
          path: 'article',
          name: 'article',
          component: () => import('@/views/article/index.vue'),
          props: true,
          meta: {
            nav: 'article'
          }
        },

        // 职场充电详情
        {
          path: 'article/:id',
          name: 'articleDetail',
          component: () => import('@/views/article/detail.vue'),
          props: true,
          meta: {
            nav: 'article'
          }
        },

        // 下载
        {
          path: 'download',
          name: 'download',
          component: () => import('@/views/Download.vue'),
          props: true,
          meta: {
            nav: 'download'
          }
        },

        {
          path: 'setting',
          name: 'OrderSetting',
          component: () => import('@/views/Order'),
          prop: true,
          meta: {
            nav: 'setting'
          }
        },
        {
          path: 'recharge',
          name: 'OrderRecharge',
          component: () => import('@/views/recharge'),
          prop: true,
          meta: {
            nav: 'recharge'
          }
        },

        {
          path: 'saff',
          name: 'saff',
          component: () => import('@/views/Saff'),
          prop: true,
          meta: {
            nav: 'saff'
          }
        },

        {
          path: 'study/:id/learn',
          name: 'study',
          component: () => import('@/views/Study'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'study/:id/task',
          name: 'task',
          component: () => import('@/views/Task'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'ceping',
          name: 'ceping',
          component: () => import('@/views/ceping/index.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'ask',
          name: 'ask',
          component: () => import('@/views/ask/index.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        },

        {
          path: 'ask/new',
          name: 'ask-new',
          component: () => import('@/views/ask/new.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        },

        {
          path: 'ask/:id',
          name: 'ask-detail',
          component: () => import('@/views/ask/detail.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!store.state.uname
  if (to.meta.unauth === true) {
    next()
  } else {
    if (!isLoggedIn) {
      // 如果用户未登录，访问其他页面则重定向到登录页
      next('/login')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js